<template>
  <div class="row" v-if="listShelfs">
    <div class="col">
      <table class="table table-dark table-striped" v-for="shelf in arrayShelfs" v-bind:key="shelf">
        <thead>
          <tr>
            <th><span class="text-uppercase">{{scaned}}</span> - {{shelf}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="products in productsInShelf(shelf)" v-bind:key="products.nazwa">
            <td>{{products.nazwa}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import { defineComponent } from '@vue/composition-api'

export default {
  name: 'ProductsListShelf',
  props: {
  },

  data () {
    return {
    }
  },

  methods: {
    productsInShelf (shelf) {
      let p = this.products_list_shelf
      console.log(
        Object.keys(p)
      )
      let pf = Object.keys(p)
        .filter(key => [shelf].includes(key))
        .reduce(
          (obj, key) => {
            obj = p[key]
            return obj
          }, {})
      console.log(shelf, pf)
      return pf
    }
  },

  computed: {
    ...mapState(['products_list_shelf', 'scaned']),
    listShelfs () {
      return Object.keys(this.products_list_shelf).length
    },
    arrayShelfs () {
      return Object.keys(this.products_list_shelf)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ProductsListShelf.vue